#import "../../../../core/graphql/fragments/team-fragment.graphql"
#import "../fragments/assigned-user-fragment.graphql"

fragment ManagedMeetingFragment on Meeting {
    id
    assignments {
        edges {
            meetings {
                id
                name
                htmlUrlPath
                hosts {
                    id
                    name
                }
                bookings {
                    id
                }
                isSevered
                deletedTime
                validity {
                    isBookable
                }
            }
            node {
                id
                assigneeEntity {
                    ... on User {
                        ...AssignedUserFragment
                    }
                    ... on Team {
                        ...TeamFragment
                    }
                }
            }
        }
    }
}
